"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Legal_1 = require("./Legal");
exports.default = Legal_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Legal/index.js
// module id = 1777
// module chunks = 8